module.exports = __webpack_public_path__ + "img/ad1bd86.webp";